module.exports = __webpack_public_path__ + "static/media/reside-logo.c635e8f1.svg";